import {
  addDays,
  differenceInDays,
  differenceInMinutes,
  parseISO,
  setHours,
  setMinutes,
  setSeconds,
  startOfDay,
} from "date-fns";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { useTimeZoneContext } from "../../../lib/context/TimeZone/TimeZoneContext";

export const DAY_LABELS = {
  today: "Today",
  tomorrow: "Tomorrow",
};

export const getDaysRangeArray = (startDate: Date, daysCount: number) => {
  const res = [startDate];

  for (let i = 0; i < daysCount - 1; i++) {
    res.push(addDays(startDate, i + 1));
  }

  return res;
};

export const useFormatReservationDate = (date: Date | number) => {
  const { timeZone } = useTimeZoneContext();

  const dayDifference = differenceInDays(
    startOfDay(date),
    startOfDay(toZonedTime(new Date(), timeZone))
  );

  if (dayDifference === 0) {
    return `${DAY_LABELS.today}, ${format(date, "MMM dd")}`;
  }

  if (dayDifference === 1) {
    return `${DAY_LABELS.tomorrow}, ${format(date, "MMM dd")}`;
  }

  return format(date, "EEEE, MMM dd");
};

export const forReservationDate = (date: Date | number, timeZone: string) => {
  const dayDifference = differenceInDays(
    startOfDay(date),
    startOfDay(toZonedTime(new Date(), timeZone))
  );

  if (dayDifference === 0) {
    return `Today, ${format(date, "MMM dd")}`;
  }

  if (dayDifference === 1) {
    return `Tomorrow, ${format(date, "MMM dd")}`;
  }

  return format(date, "EEEE, MMM dd");
};

export const createFilterPassedTime = (dayISO: string, timeZone: string) => {
  return (time: Date) => {
    if (
      differenceInDays(
        startOfDay(parseISO(dayISO)),
        startOfDay(toZonedTime(new Date(), timeZone))
      ) > 0
    ) {
      return true;
    }

    const currentDate = toZonedTime(new Date(), timeZone);

    return currentDate.getTime() < new Date(time).getTime();
  };
};

export const getAllDayTimeWindow = (dayISO: string, timeZone: string) => {
  const end = setHours(
    setMinutes(setSeconds(toZonedTime(new Date(), timeZone), 0), 0),
    24
  );

  const start =
    differenceInDays(
      startOfDay(parseISO(dayISO)),
      startOfDay(toZonedTime(new Date(), timeZone))
    ) > 0
      ? end
      : toZonedTime(new Date(), timeZone);

  return { start, end };
};

export const getDuration = (from: Date, until: Date) => {
  const allMinutes = differenceInMinutes(until, from);

  const days = Math.floor(allMinutes / (60 * 24));
  const hours = Math.floor((allMinutes % (60 * 24)) / 60);
  const minutes = allMinutes % 60;

  return { days, hours, minutes };
};
